<template>
    <section class="update-password-view">
        <HeaderComponent :title="'Alterar senha'"/>
        <div class="updt-pass-container">
            <InputContainer :inputs="fields" ref="updateInputs" />

            <div class="button-cont">
                <ButtonCenter :button="buttonUpdate" style="width: calc(100% - 30%);" @click="buttonUpdate.action && buttonUpdate.action()" />
            </div>
        </div>
    </section>
</template>

<script>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import InputContainer from '@/components/inputs/InputContainer.vue'
import ButtonCenter from '@/components/buttons/center/ButtonCenter.vue'
import { changePassword } from '@/components/controllers/ConsumerController.js'
import { showAlertNotification, showSuccessNotification, showErrorNotification } from '@/libs/Util'

export default {
    name: 'UpdatePasswordView',
    components: {
        HeaderComponent,
        InputContainer,
        ButtonCenter
    },
    data () {
        return {
            fields: [
                {
                    display: 'Senha atual',
                    placeholder: 'Senha',
                    type: 'password',
                    required: true
                },
                {
                    display: 'Nova senha',
                    placeholder: 'Nova senha',
                    type: 'password',
                    required: true
                },
                {
                    display: 'Confirmar nova senha',
                    placeholder: 'Confirmar a senha',
                    type: 'password',
                    required: true
                }
            ],
            buttonUpdate: {
                display: 'Atualizar',
                fill: true,
                action: this.update
            }
        }
    },
    methods: {
        update () {
            const values = this.$refs.updateInputs.getValues()

            // get the values from the inputs
            const oldPassword = values[0]?.value.replace(/\s+/g, '')
            const newPassword = values[1]?.value.replace(/\s+/g, '')
            const newPasswordConfirmation = values[2]?.value.replace(/\s+/g, '')

            // check if one of the fields is empty
            if (!oldPassword || !newPassword || !newPasswordConfirmation) {
                showAlertNotification({
                    title: '',
                    text: 'Preencha todos os campos.'
                })
                return false
            }

            // check if the new password and the confirmation are the same
            if (newPassword !== newPasswordConfirmation) {
                showAlertNotification({
                    title: '',
                    text: 'A nova senha e a confirmação devem ser iguais.'
                })
                return false
            }

            changePassword(oldPassword, newPassword)
                .then((res) => {
                    if (res.error) {
                        showErrorNotification({
                            title: '',
                            text: res.message
                        })
                        return false
                    } else if (res.rowsAffected) {
                        showSuccessNotification({
                            title: '',
                            text: 'Senha alterada com sucesso.'
                        })
                        this.$router.push('/home')
                    }
                })
                .catch((err) => {
                    showAlertNotification({
                        title: '',
                        text: err
                    })
                })
        }
    }
}
</script>

<style lang="less" scoped>
.updt-pass-container {
    .button-cont {
        margin-top: 50px;
    }
}

</style>
